import React from 'react';
import Link from 'next/link';
import Wrap from '../../depi/sections/Wrap';

import Typography from '@material-ui/core/Typography';
import MuiButton from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

const ConsumerSection = () => {
  const linkContext = process.env.NODE_ENV === 'production' ? '/' : `/depi/`;

  return (
    <Wrap maxWidth={800}>
      <Typography variant="h2" data-underline>
        Für Verbraucher
      </Typography>
      <Typography variant="h6" align="center">
        Verlassen Sie sich bei Einbau und Wartung Ihrer Pelletfeuerung auf
        qualifizierte Heizungsbauer und geschulte Fachstudios für
        Pelletkaminöfen.
      </Typography>
      <Box textAlign="center" mt={4} mb={8}>
        <Link
          href={`${linkContext}[...pageId]`}
          as={`${linkContext}pelletfachbetriebe-und-ofenstudios`}
          passHref
        >
          <MuiButton size="large" variant="outlined">
            Pelletprofis finden
          </MuiButton>
        </Link>
      </Box>
      <Typography variant="h6" align="center">
        Achten Sie beim Pelletkauf auf das ENplus-Zertifikat. Es garantiert
        einwandfreie Pelletqualität und kompetente Lieferung.
      </Typography>
      <Box textAlign="center" mt={4}>
        <MuiButton
          href="https://www.enplus-pellets.de/unternehmen-finden"
          target="_blank"
          size="large"
          variant="outlined"
        >
          EN<i>plus</i>-Händler finden
        </MuiButton>
      </Box>
    </Wrap>
  );
};

export default ConsumerSection;
